import {GridInitializer, GridInitializerOptions} from '../../../interfaces';

/**
 * No grid initializer options
 */
export interface NoGridInitializerOptions extends GridInitializerOptions
{
}

/**
 * No grid initializer that does nothing
 */
export interface NoGridInitializer extends GridInitializer
{
}